import { Flex } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";

import ProductsList from "../components/ProductList/ProductsList";
import FiltersDesktop from "../components/Filters/FiltersDesktop";
import FiltersMobile from "../components/Filters/mobile/FiltersMobile";
import { memo } from "react";
import InfoOnProductsPage from "../components/InfoOnProductsPage/InfoOnProductsPage";
import ItemInfoDesktop from "../components/ItemInfo/ItemInfoDesktop";
import RefreshPopup from "../components/RefreshPopup/RefreshPopup";
import { useAtom } from "jotai";

import ProductGroupList from "../components/ProductList/ProductGroupList";
import ListingsList from "../components/ProductList/ListingsList";
import VendorBanner from "../components/VendorBanner/VendorBanner";
import { allCategoryInfoAtom } from "../atom/calibers";
import { categoriesPageModeAtom } from "../atom/listings";

const ProductsPage = ({ slider = false }) => {
  const location = useLocation();
  const [customHTML, setCustomHTML] = useState(null);

 const [allCalibers] = useAtom(allCategoryInfoAtom);
  const [chooseCaliber, setChooseCaliber] = useState(null);

  const [newQuery, setNewQuery] = useState(null);

  const currentCaliber = useMemo(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    return pathSegments[1] || null;
  }, [location.pathname]);

  useEffect(() => {
    if (allCalibers.length > 0 && currentCaliber) {
      const matchedCaliber = allCalibers
        .flatMap((item) => item.calibers)
        .find((caliberItem) => {
          return caliberItem.seo_caliber === currentCaliber;
        });

      if (matchedCaliber) {
        setChooseCaliber(matchedCaliber.caliber);
      }
    }
    // eslint-disable-next-line
  }, [allCalibers, currentCaliber]);

  useEffect(() => {
    const updatedState = `${location.pathname}${location.search}`;

    let finalQuery = updatedState;
    if (chooseCaliber && !location.search.includes("caliber=")) {
      const encodedCaliber = encodeURIComponent(chooseCaliber);
      finalQuery = updatedState.includes("?")
        ? `${updatedState}&caliber=${encodedCaliber}`
        : `${updatedState}?caliber=${encodedCaliber}`;
    }

    if (slider) {
      const productIdMatch = location.pathname.match(/-(\d+)(?:\?|$)/);
      const productId = productIdMatch ? productIdMatch[1] : null;

      if (productId) {
        const existingSearchParams = location.search ? location.search : "";
        finalQuery = `product/${productId}${existingSearchParams}`;
      }
    }

    setNewQuery(finalQuery);
  }, [chooseCaliber, slider, location.pathname, location.search]);

  const [categoriesPageMode] = useAtom(categoriesPageModeAtom);
  const isListingsMode = useMemo(
    () => categoriesPageMode === "listings",
    [categoriesPageMode],
  );

  return (
    <>
      <RefreshPopup />
      <Flex
        maxW={"1240px"}
        w={"100%"}
        mx={"auto"}
        pt={{ base: "22px", lg: "45px" }}
        flexDirection={"column"}
        mb={{ base: "72px", md: "64px" }}
        px={{ base: "22px", lg: "10px" }}
      >
        {(location.pathname.includes("aguila") ||
          location.search.includes("algulia=true")) && (
          <Flex justifyContent={"center"} w={"100%"} mt={"10px"} mb={"20px"}>
            <VendorBanner />
          </Flex>
        )}

        <InfoOnProductsPage
          slider={slider}
          locationState={newQuery}
          setCustomHTML={setCustomHTML}
          caliber={currentCaliber}
        />
        <Flex justifyContent={"space-between"} w={"100%"} gap={"20px"}>
          {slider ? <ItemInfoDesktop /> : <FiltersDesktop />}

          {slider ? (
            <ProductGroupList
              slider={slider}
              locationState={newQuery}
              customHTML={customHTML}
            />
          ) : isListingsMode ? (
            <ListingsList locationState={newQuery} customHTML={customHTML} />
          ) : (
            <ProductsList locationState={newQuery} customHTML={customHTML} />
          )}
        </Flex>
        {!slider && <FiltersMobile />}
      </Flex>
    </>
  );
};

export default memo(ProductsPage);